import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { Team } from 'api-client';

export default function TeamDirectory({ teams }: { teams: Team[] }) {
  if (!teams.length)
    return <Typography>No teams yet. Create your first team or accept an invitation below.</Typography>;
  return (
    <TableContainer component={Paper} role="region" aria-label="Team directory" tabIndex={0}>
      <Table aria-label="My teams">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {teams.map((team) => (
            <TableRow key={team.id}>
              <TableCell component="th" scope="row">
                {team.name}
              </TableCell>
              <TableCell>
                <Stack direction="row" useFlexGap flexWrap="wrap" gap={1}>
                  <Button variant="contained" href={team.dashboardUrl}>Switch to this team</Button>
                  {team.slug && (
                    <Button component={RouterLink} to={`/teams/edit/${encodeURIComponent(team.slug)}`} size="small">
                      {team.isAdmin ? 'Edit' : 'View Details'}
                    </Button>
                  )}
                  {team.isAdmin && team.slug && (
                    <Button component={RouterLink} to={`/teams/settings/${encodeURIComponent(team.slug)}`} size="small">
                      Settings
                    </Button>
                  )}
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
